import { render } from "./PharmacyQueueModal.vue?vue&type=template&id=c2cff6fc"
import script from "./PharmacyQueueModal.vue?vue&type=script&lang=js"
export * from "./PharmacyQueueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__